import { createSelector } from 'reselect';
import { PapiGallection } from '@wix/da-types-papi';
import { AppState } from '../../types/store';
import {
  galleryFolderSchema,
  collectionFolderSchema,
} from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { getDenormalizedDataEntityById } from '@wix/da-shared-react/pkg/redux/entities';
import { GallectionType } from '@wix/da-shared-react/pkg/types/gallection';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
import { getGallectionSectionType } from './gallectionSection';
import { getDefaultFolderFromFolders } from '../components/Sections/GallectionsSection/helpers';

export const getFolderById = (
  state: AppState,
  gallectionType: GallectionType,
  id: number
): PapiGallection =>
  getDenormalizedDataEntityById(
    state,
    gallectionType === 'gallery' ? galleryFolderSchema : collectionFolderSchema,
    id
  );

export const getFoldersByIds = (
  state: AppState,
  gallectionType: GallectionType,
  ids
): PapiGallection[] => ids.map(id => getFolderById(state, gallectionType, id));

const putScrapsFolderLast = (a, b) =>
  b.folderId === SCRAPS_FOLDER_ID ? -1 : 0;

export const getFolders = (state: AppState) =>
  getFoldersByGallectionType(state, getGallectionSectionType(state)).sort(
    putScrapsFolderLast
  );

export const getDefaultFolder = (state: AppState) =>
  getDefaultFolderFromFolders(getFolders(state));

export const getFolderIds = state =>
  state.folders[`${getGallectionSectionType(state)}Folders`].ids || [];

export const getFoldersByGallectionType = (
  state: AppState,
  gallectionType: GallectionType
): PapiGallection[] => {
  return getFoldersByIds(
    state,
    gallectionType,
    state.folders[`${gallectionType}Folders`].ids || []
  );
};

export const getSubfolders = (state: AppState, folderId: number | undefined) =>
  getSubfoldersByGallectionType(
    state,
    getGallectionSectionType(state),
    folderId
  );

export const getSubfoldersByGallectionType = (
  state: AppState,
  gallectionType: GallectionType,
  folderId: number | undefined
): PapiGallection[] => {
  return getFoldersByGallectionType(state, gallectionType).filter(
    gallection => gallection.parentId === folderId
  );
};

export const getFeaturedFolder = createSelector(
  [getFolders],
  folders => folders.find(({ name }) => name === 'Featured') || folders[0]
);

export const getAllDeviationsFolder = createSelector(
  [getFolders],
  folders => folders.find(({ folderId }) => folderId === ALL_FOLDER_ID)
);

export const hasAnyDeviations = (state: AppState): boolean => {
  const allFolder = getAllDeviationsFolder(state);
  const featuredFolder = getFeaturedFolder(state);
  return (
    (!!allFolder && allFolder.size > 0) ||
    (!!featuredFolder && featuredFolder.size > 0)
  );
};
